// Footer.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhoneAlt, FaFacebook, FaInstagram, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import logo from '../../img/logo.png';
import './Footer.css';

const Footer = ({ language }) => {
  // Textos em dois idiomas
  const services = {
    pt: ['Manutenção predial', 'Tecnologia de Informação', 'Consultoria'],
    en: ['Building Maintenance', 'Information Technology', 'Consultancy'],
  };

  const slogan = {
    pt: 'Transformando obras em artes vivas',
    en: 'Turning construction into living art',
  };

  const followUs = {
    pt: 'Siga-nos',
    en: 'Follow us',
  };

  return (
    <footer className="footer">
      <Container>
        <Row style={{ marginTop: '40px' }}>
          {/* Logo */}
          <Col className="logo-container">
            <img src={logo} alt="Logo" />
          </Col>

          {/* Lista de Serviços */}
          <Col>
            <ul className="services-list">
              {services[language].map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
          </Col>

          {/* Slogan + Redes Sociais */}
          <Col>
            <p className="footer-text">{slogan[language]}</p>
            <div className="social-media-container">
              <span>{followUs[language]}</span>
              <a
                href="https://www.facebook.com/profile.php?id=61568662172580"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/n.wayami/profilecard/?igsh=MWM1Mmc1aDN2ZWJkeA%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/n-wayami/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </div>
          </Col>

          {/* Contatos */}
          <Col className="footer-contact">
            <p>
              <a href="tel:+244972614886">
                <FaPhoneAlt className="contact-icons" />
                +244 972 614 886
              </a>
            </p>
            <p>
              <a href="mailto:geral@nwayami.com">
                <FaEnvelope className="contact-icons" />
                geral@nwayami.com
              </a>
            </p>
            <Row className="d-flex align-items-center justify-content-center" style={{ marginBottom: '45px' }}>
              <Col xs="auto">
                <MdLocationOn className="contact-icons" />
              </Col>
              <Col className="address-container">
                <div>
                  Centralidade do Kilamba
                  <br />
                  Quarteirão F, edifício F27
                  <br />
                  apartamento 91
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
